.panel {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.error {
  margin: 0;
  color: var(--error);
  font-size: var(--fs-sm);
}

.layout {
  display: grid;
  grid-template-columns: minmax(240px, 320px) 1fr;
  gap: var(--sp-5);
  align-items: start;
}

@media (max-width: 760px) {
  .layout {
    grid-template-columns: 1fr;
  }
}

.side {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

.newChat {
  align-self: flex-start;
}

.search {
  position: relative;
}

.found {
  list-style: none;
  margin: var(--sp-2) 0 0;
  padding: 0;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  overflow: hidden;
}

.foundItem {
  display: block;
  width: 100%;
  padding: var(--sp-3) var(--sp-4);
  border: none;
  background: none;
  text-align: left;
  font-size: var(--fs-sm);
  cursor: pointer;
}

.foundItem:hover {
  background: var(--surface-2);
}

.empty,
.placeholder {
  color: var(--text-3);
  font-size: var(--fs-sm);
  margin: var(--sp-5) 0;
  text-align: center;
}

.chats {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  overflow: hidden;
}

.chats li + li {
  border-top: 1px solid var(--border);
}

.chat {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  width: 100%;
  padding: var(--sp-3) var(--sp-4);
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}

.chat:hover {
  background: var(--surface-2);
}

.chatActive {
  background: var(--surface-sunken);
}

.chatHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
}

.chatEmail {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text);
  overflow-wrap: anywhere;
}

.deleted {
  color: var(--text-3);
  font-weight: 400;
}

.unread {
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--error);
  color: var(--text-inverse);
  font-size: var(--fs-xs);
  font-weight: 600;
}

.preview {
  font-size: var(--fs-xs);
  color: var(--text-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chatTime {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.pager {
  display: flex;
  justify-content: center;
  gap: var(--sp-4);
}

.threadPane {
  display: flex;
  flex-direction: column;
  min-height: 420px;
  max-height: 70vh;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  overflow: hidden;
}

.threadHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
  border-bottom: 1px solid var(--border);
  background: var(--surface-2);
}

.threadUser {
  font-size: var(--fs-md);
  font-weight: 600;
  overflow-wrap: anywhere;
}

.threadName {
  color: var(--text-2);
  font-weight: 400;
}

.threadActions {
  display: flex;
  gap: var(--sp-2);
  flex: none;
}

/* Язык интерфейса пользователя — чтобы отвечать на нём же. */
.langBadge {
  margin-left: var(--sp-2);
  padding: 0 var(--sp-2);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  font-size: var(--fs-xs);
  font-weight: 600;
  color: var(--text-2);
  vertical-align: middle;
}

/* Завершённая сессия: история видна только админке — серым. */
.archived {
  opacity: 0.55;
  background: var(--surface-sunken);
}

.filesToggle {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-size: var(--fs-sm);
  color: var(--text-2);
  cursor: pointer;
  white-space: nowrap;
}

.attach {
  flex: none;
}

.image {
  max-width: 100%;
  max-height: 240px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
}

.fileLink {
  font-size: var(--fs-md);
  color: var(--text);
  overflow-wrap: anywhere;
}

.messages {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-5);
}

.mine,
.theirs {
  max-width: 75%;
  padding: var(--sp-3) var(--sp-4);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
}

/* «Свои» здесь — сообщения админа. */
.mine {
  align-self: flex-end;
  background: var(--flight-bg);
}

.theirs {
  align-self: flex-start;
  background: var(--surface-2);
}

.text {
  margin: 0;
  font-size: var(--fs-md);
  color: var(--text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.meta {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.composer {
  display: flex;
  align-items: flex-end;
  gap: var(--sp-3);
  padding: var(--sp-4) var(--sp-5);
  border-top: 1px solid var(--border);
}

.input {
  flex: 1;
  resize: none;
}
